import { render, staticRenderFns } from "./AllDesigns.vue?vue&type=template&id=60ee5dcf&"
import script from "./AllDesigns.vue?vue&type=script&lang=js&"
export * from "./AllDesigns.vue?vue&type=script&lang=js&"
import style0 from "./AllDesigns.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports